export default "__VITE_ASSET__CgQIZl6m__"